module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-22f03a16.svg";